// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LREAE8CrbAS61HK19cjn{overflow-anchor:none;contain:content;width:100%;height:100%;overflow-x:hidden;overflow-y:auto}.PfoBiDncqy0ywWMiHCxY{width:100%;position:relative}.Fy5RmXVzVM8bJon4XSM2{background:var(--background-neutral-subtle);border-radius:6px;width:100%}.QgIiGIwVh74q3O72tSTa,.gZf0e0LpkxKC7akdWUKQ{width:100%;position:absolute;top:0;left:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scroll": `LREAE8CrbAS61HK19cjn`,
	"inner": `PfoBiDncqy0ywWMiHCxY`,
	"skeleton": `Fy5RmXVzVM8bJon4XSM2`,
	"item": `QgIiGIwVh74q3O72tSTa`,
	"header": `gZf0e0LpkxKC7akdWUKQ`
};
export default ___CSS_LOADER_EXPORT___;
